export default "__VITE_ASSET__CSDl$5q$__"